import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { RequestUserSubmitDto, ResponseTodayFormDto } from "../dto/worklocation.dto";

@Injectable()
export class WorklocConfirmationNestApi {
  private service: string = '';
  private model: string = 'workloc-confirmation';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }

  public todayForm() {
    const method: string = 'GET';
    const func: string = 'user/today-form';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseTodayFormDto[]>>(method, url, params, urlParams, body);
  }

  public submitForm(payload: RequestUserSubmitDto) {
    const method: string = 'POST';
    const func: string = 'user/submit';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseTodayFormDto>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/workloc-confirmation.api.ts